import { showMessage } from 'app/store/fuse/messageSlice';
import store from 'app/store/index';
import i18next from 'i18next';

const handleError = (error) => {
  const currentLanguage = i18next.language;
  let errorMessage = i18next.t('Ошибка', { ns: 'translations' });

  if (!error.response) {
    errorMessage = error.message || 'Error';
  } else {
    const { status, data, statusText } = error.response;

    if (status === 401) {
      console.error('Authorization error');
      errorMessage = 'Authorization error. Log in again...';
      return;
    } else if (data === 404) {
      errorMessage =
        currentLanguage === 'ru'
          ? 'Пользователь не найден. Проверьте имя пользователя и пароль'
          : 'Foydalanuvchi topilmadi. Iltimos, foydalanuvchi nomi va parolni tekshiring';
    } else if (status === 400) {
      if (typeof data.data === 'string') {
        errorMessage = i18next.t(data.data, { ns: 'translations' });
      } else if (typeof data === 'object' && data !== null) {
        errorMessage = data;
      }
    } else {
      errorMessage = data
        ? JSON.stringify(data)
        : `На сервере ведутся работы. Попробуйте позже... ${status ? status : ''} ${statusText}`;
    }
  }

  store.dispatch(
    showMessage({
      message: <div style={{ fontWeight: 'bold', fontSize: 20 }}>{errorMessage}</div>,
      variant: 'error',
      autoHideDuration: 5000,
    })
  );
};

export default handleError;
